/*
 * Created by: cparaschiv
 * Date: 06.01.2015, 10:46
 */

(function($){

    var show = function (parent, child) {
        $(parent).addClass('active');
        $(child).show();
        $('.dropdown.user.open').removeClass('open');
        $('.user-toggle').blur();
    };

    var hide = function (parent, child) {
        $(parent).removeClass('active');
        $(child).hide();
    };

 	$.fn.extend({

 		TsMainMenu: function() {
    		return this.each(function() {
                var parent, child,
                    sel;

                parent = $(this);
                sel = '.submenu[data-parent-menu="' + parent.attr('id') + '"]';
                child = $(sel);

                parent && $(parent).hover(function(){
                    show(parent, child);
                }, function(){
                    hide(parent, child);
                });

                child && $(child).hover(function(){
                    show(parent, child);
                }, function(){
                    hide(parent, child);
                });
    		});
    	}
	});
})(window.jQuery);
